import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/modules/auth/services/auth.service';
import { LoginDto } from 'app/modules/auth/services/payloads/login.dto';
import { LocalStorageService } from 'app/shared/services/local-storage.service';
import { SeoService } from 'app/shared/services/seo.service';
import { ToastService } from 'app/shared/services/toast.service';
import { Subject } from 'rxjs';
import { Business, BusinessService } from '../../../setting/business';
import { BusinessType } from '../../../setting/business/domain/businessType';
import { BusinessPermissionsType } from '../../../setting/business/domain/businessPermissions';
import { UserService } from '../../../setting/user';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnDestroy {
  isLoading: boolean = false;
  isWAForm: boolean = false;
  business: Business;
  businesses: Business[];
  businessId: string;
  accessDenied: boolean;

  private _unsubscribeAll: Subject<any>;
  constructor(
    private _seoService: SeoService,
    private _authService: AuthService,
    private _router: Router,
    private _toastService: ToastService,
    private _localStorageService: LocalStorageService,
    private _businessService: BusinessService,
    private _userService: UserService
  ) {
    this._seoService.setMetaTitle('Login | Fooder');
    this._unsubscribeAll = new Subject();
  }

  login(input: LoginDto) {
    this.isLoading = true;
    this._authService.login(input).subscribe({
      next: (_) => {
        this.businessId = this._localStorageService.getItem('active_business');

        this.checkPermission();
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this._toastService.error('DATA.LABELS.OPS', 'DATA.ERRORS.INVALID_CRED');
      },
    });
  }

  checkPermission() {
    this.business = this._businessService.getActiveBusiness(this.businessId);
    this.businesses = this._businessService.businessesValue;

    // If the active business has permission, redirect to admin
    if (
      this.business.permission?.permissions?.includes(
        BusinessPermissionsType.LOGIN_ACCESS
      )
    ) {
      return this.navigateToAdmin(this.business.type);
    }

    // Check if other businesses have permission
    const activeBusiness = this.businesses.find((business) =>
      business.permission?.permissions?.includes(
        BusinessPermissionsType.LOGIN_ACCESS
      )
    );

    // If found, set the new active business in local storage, and redirect to admin
    if (activeBusiness) {
      this.business = activeBusiness;
      this.businessId = activeBusiness.id;
      this._localStorageService.setItem('active_business', this.businessId);
      return this.navigateToAdmin(activeBusiness.type);
    }

    // If no active businesses with permission. logout.
    this.isLoading = false;
    this._toastService.error(
      'DATA.LABELS.OPS',
      'DATA.ERRORS.BUSINESS_PERMISSION_DENIED'
    );
    this._authService.logout();
  }

  navigateToAdmin(businessType: BusinessType) {
    this._router.navigate([
      '/business',
      this.businessId,
      this._userService.defaultRoute(businessType),
    ]);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
